module.exports = __webpack_public_path__ + "4a42fa46132c3213d839a178cab6be02.svg";